import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import StatusTag from "@/components/feature/StatusTag";
import { formatDate, getLatestTimeline } from "@/lib/site";

const legend = [
  { label: "发酵中", tone: "hot" as const, desc: "讨论仍在扩大，暂无结论" },
  { label: "已回应", tone: "reply" as const, desc: "当事方已公开说明" },
  { label: "已澄清", tone: "clear" as const, desc: "关键争议已有可核实结论" },
  { label: "持续追踪", tone: "track" as const, desc: "跨度较长，长期跟进" },
];

export default function LatestFeed() {
  const entries = getLatestTimeline(6);

  return (
    <section id="latest" className="scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              eyebrow="Live Feed"
              title="最新进展 · 按时间倒序"
              description="只展示带明确出处的节点。每条进展都注明了它属于哪件事，点进去可以看到完整脉络。"
            />
            <div className="mt-6 space-y-3 rounded-lg border border-background-200 bg-background-100 p-4">
              <p className="text-xs font-medium uppercase tracking-[0.16em] text-foreground-500">
                状态标记说明
              </p>
              <ul className="space-y-2">
                {legend.map((item) => (
                  <li key={item.label} className="flex items-center gap-3">
                    <StatusTag label={item.label} tone={item.tone} />
                    <span className="text-xs text-foreground-600">{item.desc}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Link
              to="/topics"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-archive-2-line" aria-hidden="true" />
              进入话题档案
            </Link>
          </div>

          <ol className="space-y-6 border-l border-background-200 pl-6">
            {entries.map((entry) => (
              <li key={`${entry.topicId}-${entry.date}-${entry.title}`} className="relative">
                <span
                  className="absolute -left-[31px] top-[6px] h-3 w-3 rounded-full border-2 border-background-50 bg-primary-500"
                  aria-hidden="true"
                />
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="font-medium text-foreground-800">
                    {formatDate(entry.date)}
                  </span>
                  <StatusTag label={entry.status} tone={entry.statusTone} />
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                  {entry.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.detail}</p>
                <Link
                  to={`/topic/${entry.topicId}`}
                  className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  <i className="ri-links-line" aria-hidden="true" />
                  {entry.topicTitle}
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}